module.exports = __webpack_public_path__ + "static/media/grid2.f367fc0c.jpg";